import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { useSavingsStore } from '@/store/useSavingsStore'
import { useUserStore } from '@/store/useUserStore'
import { useGetWallet, type WalletCurrency } from '@/domain'
import { currencyUtils } from '@/utils'

const { cryptoToBig, formatDynamicCurrency } = currencyUtils

export const TransferInAvailableWalletAmount: React.FC = () => {
  const { t } = useTranslation()

  const setGoalTransferIn = useSavingsStore((s) => s.setGoalTransferIn)
  const wallet = useUserStore((s) => s.wallet)
  const displayCurrency = wallet?.displayCurrency || 'USD'

  // Получаем актуальные данные кошелька из API
  const { data: walletData } = useGetWallet()

  // Используем данные из API если доступны, иначе из store
  const completeCurrencies =
    walletData?.completeCurrencies || wallet?.completeCurrencies

  // Находим USDT в кошельке пользователя
  const usdtWallet = completeCurrencies?.find(
    (currency: WalletCurrency) => currency.code === 'USDT',
  )

  const handlePress = () => {
    if (!usdtWallet) return

    const bigAmount = cryptoToBig({
      amount: usdtWallet.amount ?? '0',
    })

    // Используем точную fiat сумму из кошелька вместо конвертации
    // чтобы избежать потери точности при округлении
    const fiatAmount = String(usdtWallet.fiatAmount ?? 0)

    setGoalTransferIn({
      isFiatMode: false, // Остаемся в crypto режиме при выборе максимума (как в других компонентах)
      cryptoAmount: {
        amount: bigAmount,
        code: usdtWallet.code ?? 'USDT',
      },
      fiatAmount: {
        amount: fiatAmount,
        code: usdtWallet.fiatCurrency || displayCurrency,
      },
    })
  }

  // Форматируем доступную сумму (показываем даже если 0)
  const formattedAmount = formatDynamicCurrency({
    amount: usdtWallet?.amount ?? '0',
    currencyCode: usdtWallet?.code ?? 'USDT',
    showDecimals: true,
  })

  return (
    <BaseView
      center
      className="cursor-pointer hover:opacity-80 active:opacity-60 transition-opacity duration-150"
      onClick={handlePress}
      style={{
        padding: '8px 16px',
        borderRadius: '8px',
      }}
    >
      <BaseText
        fontSize={16}
        fontFamily="medium"
        color="label.clickable"
        textAlign="center"
      >
        Maximum: {formattedAmount}
      </BaseText>
    </BaseView>
  )
}
